import { TickerOption } from '@/modules/asset/views/add-asset/components/ticker-option'
import { EAssetType, getRefId, type ICryptoQuote, type ISavedDocument } from 'findef'
import type { FormFieldOption } from '../useForm'

export const cryptoQuoteToOption = (
  crypto: ISavedDocument<ICryptoQuote> | ISavedDocument<ICryptoQuote, string> | ICryptoQuote
): FormFieldOption => {
  const label = crypto.name || crypto.symbol || '?'
  return {
    label: label,
    key: getRefId(crypto),
    value: crypto,
    body: (props) => {
      return (
        <TickerOption
          assetType={EAssetType.CRYPTO}
          name={crypto.prettyName || crypto.name}
          symbol={crypto.manuallyAdded ? 'No Symbol' : crypto.prettySymbol || crypto.symbol}
          image={crypto.image}
          isOpen={props.isOpen}
          badge={'Crypto'}
        />
      )
      //return <CryptoItem item={crypto} isOpen={props?.isOpen} />
    }
  }
}
